import type { ArticleData } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';
import type { Category } from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import {
	BROWSE_KNOWLEDGE_SUCCESS,
	type BrowseKnowledgeSuccessAction,
} from '../../actions/browse-knowledge-success';
import {
	FETCH_ARTICLE_SUCCESS,
	type FetchArticleSuccessAction,
} from '../../actions/fetch-article-success';
import { FETCH_CATEGORIES, type FetchCategoriesAction } from '../../actions/fetch-categories';
import {
	FETCH_CATEGORIES_FAILURE,
	type FetchCategoriesFailureAction,
} from '../../actions/fetch-categories-failure';
import {
	FETCH_CATEGORIES_SUCCESS,
	type FetchCategoriesSuccessAction,
} from '../../actions/fetch-categories-success';
import {
	SEARCH_ARTICLES_SUCCESS,
	type SearchArticlesSuccessAction,
} from '../../actions/search-articles-success';
import type { CategoriesState } from './types';

type HandledAction =
	| FetchCategoriesSuccessAction
	| FetchCategoriesFailureAction
	| FetchCategoriesAction
	| BrowseKnowledgeSuccessAction
	| SearchArticlesSuccessAction
	| FetchArticleSuccessAction;

export const defaultState: CategoriesState = {
	isLoaded: false,
	categories: [],
	isCategoriesSupported: false,
};

const reduceCategoriesFromArticles = (articles: ArticleData[], existingCategories: Category[]) => {
	const categories = [...existingCategories];

	articles // eslint-disable-next-line @typescript-eslint/no-explicit-any
		.reduce<Array<any>>((acc, article) => acc.concat(article.categories), [])
		.forEach((category) => {
			if (category && !categories.find((existingCategory) => category.id === existingCategory.id)) {
				categories.push(category);
			}
		});

	return categories;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: CategoriesState = defaultState, action: HandledAction): CategoriesState => {
	switch (action.type) {
		case FETCH_CATEGORIES_SUCCESS:
			return {
				categories: action.payload.categories,
				isCategoriesSupported: action.payload.categoriesSupported,
				isLoaded: true,
			};

		case FETCH_CATEGORIES_FAILURE:
			return {
				...state,
				error: action.payload,
				isLoaded: true,
			};

		case FETCH_CATEGORIES: {
			// Maintain existing categories and set loading state to true
			const newState = {
				...state,
				isLoaded: false,
			};

			delete newState.error;

			return newState;
		}

		case BROWSE_KNOWLEDGE_SUCCESS: {
			const newState = {
				...state,
				categories: reduceCategoriesFromArticles(action.payload.results, state.categories),
			};

			return newState;
		}

		case SEARCH_ARTICLES_SUCCESS: {
			const newState = {
				...state,
				categories: reduceCategoriesFromArticles(action.payload, state.categories),
			};

			return newState;
		}

		case FETCH_ARTICLE_SUCCESS: {
			const newState = {
				...state,
				categories: reduceCategoriesFromArticles([action.payload], state.categories),
			};

			return newState;
		}
		default: {
			return state;
		}
	}
};
